// ============================================================
// axios 实例：统一请求配置（对接真实后端）
//   - POST 统一 qs 序列化为 x-www-form-urlencoded（后端只吃表单编码）
//   - 请求自动携带 Authorization: Bearer <token>
//   - 响应直接返回后端的 { state, data, count } 结构，页面代码无需解包
//   - 401 统一处理：清除登录态并提示
// ============================================================
import axios from 'axios'
import qs from 'qs'
import { BASE_URL } from './config'

const http = axios.create({ baseURL: BASE_URL, timeout: 15000 })

// ---------------- 请求拦截 ----------------
http.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
      // FormData（上传图片）不做序列化
      if (config.data && !(config.data instanceof FormData)) {
        config.data = qs.stringify(config.data)
      }
    }
    const token = localStorage.getItem('luffy_jwt_token')
    if (token) config.headers['Authorization'] = 'Bearer ' + token
    return config
  },
  (error) => Promise.reject(error)
)

// ---------------- 响应拦截 ----------------
http.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response && error.response.status
    if (status === 401) {
      localStorage.removeItem('luffy_jwt_token')
      localStorage.removeItem('userinfo')
      error.friendlyMessage = '登录已过期，请重新登录'
    } else if (error.code === 'ECONNABORTED') {
      error.friendlyMessage = '请求超时，请检查后端服务是否启动'
    } else if (!error.response) {
      error.friendlyMessage = '无法连接后端服务（' + BASE_URL + '）'
    } else {
      error.friendlyMessage = '请求失败（HTTP ' + status + '）'
    }
    return Promise.reject(error)
  }
)

export default http
